import t from "prop-types";
import e from "react";
import a from "classnames";
import { u as B } from "./ThemeProvider--i7ESlT5.es.js";
import { T as i } from "./index-BB-Wk85r.es.js";
import { B as c } from "./Button-CY2D4L2H.es.js";
import { u as y } from "./utils-C0l876fA.es.js";
import './CruiseBody.css';const E = "CruiseBody-module__body___n1REi", N = "CruiseBody-module__compere___tGJY8", f = "CruiseBody-module__header___6Bl1Y", k = "CruiseBody-module__controls___rkDV0", g = "CruiseBody-module__singleStopControls___QiCfq", h = "CruiseBody-module__control___8ETha", v = "CruiseBody-module__counter___8ufKW", o = {
  body: E,
  compere: N,
  header: f,
  controls: k,
  singleStopControls: g,
  control: h,
  counter: v
}, u = ({
  currentStop: l,
  totalStops: r,
  onDoneClick: m,
  onNextClick: _,
  onBackClick: p,
  children: d,
  textDone: C
}) => {
  const n = B(), { t: s } = y();
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: a(
        o.body,
        n === "compere" && o.compere
      )
    },
    /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: o.header }, /* @__PURE__ */ e.createElement(i.Heading2, { tagName: "span", darkBg: !0, responsive: !0 }, d.title)), /* @__PURE__ */ e.createElement(i.Body, { tagName: "p", darkBg: !0, responsive: !0 }, d.body)),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: a(
          o.controls,
          r === 1 && o.singleStopControls
        )
      },
      r > 1 && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: a(
            o.control,
            o.counter
          )
        },
        /* @__PURE__ */ e.createElement(
          i.Body3,
          {
            darkBg: !0,
            theme: n,
            responsive: !0,
            tagName: "span"
          },
          `${l + 1}/${r}`
        )
      ),
      l > 0 && /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.CancelButton,
        {
          handleClick: p,
          theme: n
        },
        s("Go back")
      )),
      r === 1 && /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          handleClick: m,
          theme: n
        },
        s("Got it")
      )),
      r > 1 && (l < r - 1 ? /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          buttonClassName: "cta-button",
          handleClick: _,
          theme: n
        },
        s("Next")
      )) : /* @__PURE__ */ e.createElement("div", { className: o.control }, /* @__PURE__ */ e.createElement(
        c.ActionButton,
        {
          handleClick: m,
          theme: n
        },
        C || s("Done")
      )))
    )
  ));
};
u.propTypes = {
  /** Index of the stop */
  currentStop: t.number.isRequired,
  /** Number of stops in the cruise */
  totalStops: t.number.isRequired,
  /** Called when cruise is finished */
  onDoneClick: t.func.isRequired,
  /** Called when next button is clicked */
  onNextClick: t.func.isRequired,
  /** Called when back button is clicked */
  onBackClick: t.func,
  /** Text labeling the button to end the cruise at the last stop */
  textDone: t.node,
  /**
   * An object with two keys: <br/>
   * \* *title* (node, required) - the title content for the cruise stop<br/>
   * \* *body* (node, required) - the body content for the cruise stop
   */
  children: t.shape({
    title: t.node.isRequired,
    body: t.node.isRequired
  }).isRequired
};
u.defaultProps = {
  textDone: null,
  onBackClick: () => !0
};
export {
  u as C
};
